import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useSeasonOptions() {
  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchSeasonOptions() {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('plants')
          .select('season')
          .not('season', 'is', null);

        if (error) throw error;

        // Get unique values and sort them
        const uniqueOptions = Array.from(
          new Set(data.map(p => p.season))
        ).sort();

        setOptions(uniqueOptions);
      } catch (err) {
        console.error('Error fetching season options:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    }

    fetchSeasonOptions();
  }, []);

  return { options, loading, error };
}